<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EP">What leaf-fringed legends haunt about thy shape</p>
<p class="EP">Of deities or mortals, or of both,</p>
<p class="EP">In Tempe or the dales of Arkady?</p>
<p class="EP">What men or gods are these? What maidens loth?</p>
<p class="EP">What mad pursuit? What struggle to escape?</p>
<p class="EP">What pipes and timbrels? What wild ecstasy?</p>
<p class="EPC">—K<span class="ePub-SC">EATS</span>, “Ode on a Grecian Urn”</p>
<p class="EP2">Socrates: Tell me then, oh tell me—what is the great and splendid work which the gods achieve with the help of our devotions?</p>
<p class="EP2">Euthyphro: Many and fair are the works of the gods.</p>
<p class="EPC">—P<span class="ePub-SC">LATO</span>, <span class="ePub-I">Euthyphro</span></p>
<p class="EP">Answer me, answer me</p>
<p class="EP">Somebody answer me.</p>
<p class="EP">Oldest of questions and</p>
<p class="EP">Deepest of needs. Our</p>
<p class="EP">Mystery, mystery,</p>
<p class="EP">Teach us our history.</p>
<p class="EP">Lost all again</p>
<p class="EP">To the dark of the grave.</p>
<p class="EPC">—A<span class="ePub-SC">DA </span>P<span class="ePub-SC">ALMER</span>, “A New World”</p>
<p class="EP1">And now the work is done that cannot be erased by Jupiter’s anger, fire and sword, nor the gnawing tooth of time. Let the day, that has power only over my body, end when it will my uncertain span of years. The best part of me will be borne, immortal, beyond the distant stars.</p>
<p class="EPC">—O<span class="ePub-SC">VID</span>, envoi to <span class="ePub-I">Metamorphoses</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?2033a24e